import { CloseIcon, ContextMenuItem } from '@tunein/react-ui';
import { useContext } from 'react';
import { CANCEL } from 'src/common/constants/localizations/shared';
import { LocationAndLocalizationContext } from '../../../../providers/LocationAndLocalizationProvider';

export function CancelMenuItem() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <ContextMenuItem data-testid="cancelMenuItem" icon={<CloseIcon />}>
      {getLocalizedText(CANCEL)}
    </ContextMenuItem>
  );
}
